import React, { useEffect } from 'react';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { useFeedbackCreateRequestMutation } from '../api/create-feedback-request-api';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { ModalCreateFeedback } from './modal-create-feedback/modal-create-feedback';
import { CACHE_KEY_FEEDBACK_CREATE_REQUEST } from '../config/api-constants';
import { useIsShowCreateFeedbackRequestSelector } from '@entities/feedback/model/selectors';
import { useDispatch } from 'react-redux';
import { setIsShowCreateFeedbackRequest } from '@entities/feedback/model/slice';

export const CreateFeedback: React.FC = () => {
    const dispatch = useDispatch();
    const isShowModal = useIsShowCreateFeedbackRequestSelector();

    const [, createFeedbackRequestResult] = useFeedbackCreateRequestMutation({
        fixedCacheKey: CACHE_KEY_FEEDBACK_CREATE_REQUEST,
    });

    useEffect(() => {
        if (isShowModal && createFeedbackRequestResult.isSuccess) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={'Обращение отправлено'}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            dispatch(setIsShowCreateFeedbackRequest(false));
            createFeedbackRequestResult.reset();
        } else if (isShowModal && createFeedbackRequestResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Обращение не удалось отправить.\n${getQueryError(createFeedbackRequestResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            createFeedbackRequestResult.reset();
        }
    }, [isShowModal, createFeedbackRequestResult.isSuccess, createFeedbackRequestResult.isError]);

    return <ModalCreateFeedback isShow={isShowModal} />;
};
